export default {
  estaCarregando: false,
  objMotivoDevolucaoCheque: {},
  lista: [],
  motivoDevolucaoChequeSelecionadoId: null
}
